/* tslint:disable */
/* eslint-disable */
/**
 * Protected Bricks API
 * API für die Verwaltung und Analyse von Klemmbaustein-Sets auf Design-Schutzrechte
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@protectedbricks.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Part } from './Part';
import {
    PartFromJSON,
    PartFromJSONTyped,
    PartToJSON,
} from './Part';

/**
 * 
 * @export
 * @interface BrickSet
 */
export interface BrickSet {
    /**
     * Eindeutige Set-ID
     * @type {string}
     * @memberof BrickSet
     */
    id: string;
    /**
     * Name des Sets
     * @type {string}
     * @memberof BrickSet
     */
    name: string;
    /**
     * Set-Nummer
     * @type {string}
     * @memberof BrickSet
     */
    setNumber: string;
    /**
     * Datum der Analyse
     * @type {Date}
     * @memberof BrickSet
     */
    analyzedDate: Date;
    /**
     * Gesamtzahl der Steine
     * @type {number}
     * @memberof BrickSet
     */
    totalBricks: number;
    /**
     * Anzahl geschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {string}
     * @memberof BrickSet
     */
    protectedBricks: string;
    /**
     * Liste der geschützten Teilenummern
     * @type {Array<string>}
     * @memberof BrickSet
     */
    protectedBricksList?: Array<string>;
    /**
     * Anzahl ungeschützter Steine oder "ANALYZING" wenn noch nicht analysiert
     * @type {string}
     * @memberof BrickSet
     */
    unprotectedBricks: string;
    /**
     * Detaillierte Stückliste (bei ANALYZING nur erste 3 Einträge)
     * @type {Array<Part>}
     * @memberof BrickSet
     */
    partsList?: Array<Part>;
    /**
     * Gesamtanzahl der Parts in der Stückliste
     * @type {number}
     * @memberof BrickSet
     */
    totalPartsCount?: number;
    /**
     * Aktueller Analyse-Typ des Sets (falls bereits analysiert)
     * @type {string}
     * @memberof BrickSet
     */
    analyzeType?: BrickSetAnalyzeTypeEnum;
}


/**
 * @export
 */
export const BrickSetAnalyzeTypeEnum = {
    Simple: 'SIMPLE',
    Protected: 'PROTECTED',
    All: 'ALL',
    UnknownDefaultOpenApi: '11184809'
} as const;
export type BrickSetAnalyzeTypeEnum = typeof BrickSetAnalyzeTypeEnum[keyof typeof BrickSetAnalyzeTypeEnum];


/**
 * Check if a given object implements the BrickSet interface.
 */
export function instanceOfBrickSet(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "setNumber" in value;
    isInstance = isInstance && "analyzedDate" in value;
    isInstance = isInstance && "totalBricks" in value;
    isInstance = isInstance && "protectedBricks" in value;
    isInstance = isInstance && "unprotectedBricks" in value;

    return isInstance;
}

export function BrickSetFromJSON(json: any): BrickSet {
    return BrickSetFromJSONTyped(json, false);
}

export function BrickSetFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrickSet {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'setNumber': json['setNumber'],
        'analyzedDate': (new Date(json['analyzedDate'])),
        'totalBricks': json['totalBricks'],
        'protectedBricks': json['protectedBricks'],
        'protectedBricksList': !exists(json, 'protectedBricksList') ? undefined : json['protectedBricksList'],
        'unprotectedBricks': json['unprotectedBricks'],
        'partsList': !exists(json, 'partsList') ? undefined : ((json['partsList'] as Array<any>).map(PartFromJSON)),
        'totalPartsCount': !exists(json, 'totalPartsCount') ? undefined : json['totalPartsCount'],
        'analyzeType': !exists(json, 'analyzeType') ? undefined : json['analyzeType'],
    };
}

export function BrickSetToJSON(value?: BrickSet | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'setNumber': value.setNumber,
        'analyzedDate': (value.analyzedDate.toISOString()),
        'totalBricks': value.totalBricks,
        'protectedBricks': value.protectedBricks,
        'protectedBricksList': value.protectedBricksList,
        'unprotectedBricks': value.unprotectedBricks,
        'partsList': value.partsList === undefined ? undefined : ((value.partsList as Array<any>).map(PartToJSON)),
        'totalPartsCount': value.totalPartsCount,
        'analyzeType': value.analyzeType,
    };
}

